/**
 * The type of a source added to a Rovo Space.
 * Must match the values accepted by the ConvoAI spaces API.
 */
export enum SpaceSourceType {
	WebPage = 'WebPage',
	File = 'File',
}
